const FiltroDataClientes = Object.freeze({
  FIDELIZACOES: 'Fidelizações',
  CADASTRO: 'Cadastro',
  ULTIMO_ACESSO: 'Último Acesso',
});

export default FiltroDataClientes;
